import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { Box, Group, Text, Button, Modal, useMantineTheme, Center, ScrollArea, Container, Grid, SimpleGrid, Card, Avatar, Divider } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { useLoginContext } from "../../context/loginContext";
import { utils, BE_API_ONE, tabProject, menuList, subMenuProject } from "../../utils/globalVariables";
import { safeValue, stringDivider, getObjectParam2, sqlDateToHumanDate, CustomerCategoryIcon, getPropInSubLevelRole, safetyDecodeJWT } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";
import DeadlinePengecekan from "../../components/utilities/DeadlinePengecekan";
import DeadlineSelesai from "../../components/utilities/DeadlineSelesai";

const PopUpTeknisiTasks = () => {

  const theme = useMantineTheme();
  const mountedRef = React.useRef(true);
  const { loginContext, handleSetLoginContext } = useLoginContext();
  const navigate = useNavigate();

  const [data, setData] = React.useState({
    data: [],
    dataLoading: false,
    dataCount: 0,
    dataFlag: 'idle',

    modalCore: false,
    modalWhileLoading: false,
  })

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    setData(d => ({
      ...d,
      dataLoading: true,
      modalWhileLoading: true
    }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('flag_all', utils.flagAll);
    formDT.append('project_is_cancel', '0');

    formDT.append('filter_arr_proses', [utils.projectProcess.nota.value, utils.projectProcess.antrian.value, utils.projectProcess.pengerjaan.value]);

    axios({
      method: 'post',
      url: BE_API_ONE + '/pengecekan_deadline_popup',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        dataLoading: false,
        modalWhileLoading: false
      }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          modalCore: response.data.data.length > 0 ? true : false,
          data: response.data.data,
          dataCount: response.data.data_count,
          dataFlag: response.data.data.length > 0 ? true : false,
        }));
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        dataLoading: false,
        modalWhileLoading: false
      }));

      notifications.show({
        id: uuidv4(),
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }, [handleSetLoginContext, loginContext.syswebapp])

  const fnGoToStep = (stateData) => {
    setData(d => ({ ...d, modalCore: false }));

    let tab = '';
    const stateProjectStep = stateData.project_process;
    const stateCustomerId = stateData.customer_id;
    const stateProjectId = stateData.project_id;

    if (stateProjectStep === utils.projectProcess.nota.value) {
      tab = tabProject.nota;
    } else if (stateProjectStep === utils.projectProcess.antrian.value) {
      tab = tabProject.antrian;
    } else if (stateProjectStep === utils.projectProcess.pengerjaan.value) {
      tab = tabProject.pengerjaan;
    } else if (stateProjectStep === utils.projectProcess.qc.value) {
      tab = tabProject.qc;
    } else if (stateProjectStep === utils.projectProcess.selesai.value) {
      tab = tabProject.selesai;
    } else if (stateProjectStep === utils.projectProcess.sudah_diambil.value) {
      tab = tabProject.sudahDiambil;
    }

    navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${menuList.project.slug}/${subMenuProject}/${tab}/${stateProjectStep === utils.projectProcess.nota.value ? stateCustomerId : stateProjectId}`, { replace: true });
  }

  return (
    <React.Fragment>
      <Modal
        size='xl'
        opened={data.modalWhileLoading}
        // onClose={() => setData(d => ({ ...d, modalWhileLoading: false }))}
        closeOnClickOutside={false}
        closeOnEscape={false}
        withCloseButton={false}
        // title="Checking.."
        overlayProps={{
          color: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[2],
          opacity: 0.55,
          blur: 3,
        }}
      >
        <Center>Loading..</Center>
      </Modal>

      <Modal
        size='xl'
        opened={data.modalCore}
        onClose={() => setData(d => ({ ...d, modalCore: false }))}
        closeOnClickOutside={false}
        closeOnEscape={false}
        title={
          <React.Fragment>
            <Text fw='bold'>Hai, {String(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappn'))}</Text>
            <Text size='sm'>Ada {data.data.length} project yang belum kamu cek nih..</Text>
          </React.Fragment>
        }
        scrollAreaComponent={ScrollArea.Autosize}
        overlayProps={{
          color: theme.colorScheme === 'dark' ? '#000' : theme.colors.dark[9],
          opacity: theme.colorScheme === 'dark' ? 0.7 : 0.3,
          blur: 3,
        }}

        shadow="xl"
        radius='md'

        closeButtonProps={{
          size: 'lg',
          radius: 'xl',
          iconSize: '1.25rem'
        }}

        styles={(tema) => ({
          header: {
            alignItems: 'flex-start'
          },
          content: {
            // border: '1px solid red !important',
            outline: `1px solid ${tema.colorScheme === 'light' ? tema.colors.blue[4] : tema.colors.dark[5]}`
          }
        })}
      >
        {Array.isArray(data.data) && (data.data.length > 0) && data.dataFlag === true &&
          <Container fluid mt='.25rem' px={0}>
            <Grid my={0}>
              <Grid.Col
                span={12}
                py={0}
              >
                <SimpleGrid
                  cols={1}
                  spacing='md'
                  breakpoints={[
                    { minWidth: 'xl', cols: 2, spacing: 'md' },
                    { minWidth: 'lg', cols: 2, spacing: 'md' },
                    { minWidth: 'md', cols: 2, spacing: 'md' },
                    { minWidth: 'sm', cols: 2, spacing: 'md' },
                    { minWidth: 'xs', cols: 1, spacing: 'md' },
                  ]}
                >
                  {Object.keys(data.data).map((key, index) => {
                    return (
                      <Card
                        key={key}
                        // shadow='xs'
                        radius="md"
                        withBorder={true}

                        style={{
                          borderColor: theme.colorScheme === 'light' ? theme.colors.gray[4] : theme.colors.dark[6],
                          backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[0] : theme.colors.dark[6],
                          overflow: 'unset',
                          // cursor: 'pointer',
                        }}

                        onClick={() => {
                          // handleSelectedProject(data.data[key].project_id, data.data[key].customer_id, data.data[key].project_process);
                        }}
                      >
                        <Card.Section p='sm'>
                          <Text size="sm">
                            <Group>
                              <Avatar
                                radius="xl"
                                styles={(tema) => ({
                                  placeholder: {
                                    backgroundColor: tema.fn.rgba((tema.colorScheme === 'light' ? getObjectParam2(utils.priority, String(data.data[key].project_priority), 'colorBgLight', tema.colors.gray[1]) : getObjectParam2(utils.priority, String(data.data[key].project_priority), 'colorBgDark', tema.colors.dark[5])), 0.75)
                                  }
                                })}
                              >
                                <CustomerCategoryIcon
                                  stateCustomerCategory={data.data[key].customer_category_slug}
                                  stateSize='1.5rem'
                                  stateColor={theme.colorScheme === 'light' ? (data.data[key].project_priority ? '#fff' : '#000') : '#fff'}
                                />
                              </Avatar>

                              <Box>
                                <Text size="sm" fw={500} lineClamp={1}>
                                  {data.data[key].customer_name}
                                </Text>

                                <Text size="xs" lineClamp={1} color='dimmed'>
                                  {data.data[key].customer_category_name}
                                </Text>

                                <Text size="xs" lineClamp={1} color='dimmed'>
                                  {data.data[key].customer_group_name ? data.data[key].customer_group_name : '[Group]'}
                                </Text>

                                <Text size="xs" lineClamp={1} color='dimmed'>
                                  Id Card {data.data[key].customer_id_card_number ? data.data[key].customer_id_card_number : ' - '}
                                </Text>
                              </Box>
                            </Group>

                            <Divider
                              mt='.5rem'
                              mb='.5rem'
                              sx={(tema) => ({
                                borderTopWidth: '1px',
                                borderStyle: 'dashed',
                                borderTopColor: tema.colorScheme === 'light' ? tema.colors.gray[2] : tema.colors.dark[5]
                              })}
                            />

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='No Nota'
                              stateContent={
                                <React.Fragment>
                                  <Text>
                                    {stringDivider(data.data[key].project_id, [4, 6, 8], '.', '[Nomor Nota]')}
                                  </Text>

                                  <Text>
                                    {getObjectParam2(utils.projectProcess, data.data[key].project_process, 'caption', ' - ')}
                                  </Text>
                                </React.Fragment>
                              }
                              stateDivider={true}
                            />

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='Barang'
                              stateContent={
                                <Box>
                                  {data.data[key].barang_category_name ?
                                    <Text lineClamp={1}>
                                      {safeValue(data.data[key].barang_category_name, '[Kategori Barang]')}
                                    </Text>
                                    :
                                    <Text lineClamp={1} color='dimmed'>
                                      [Kategori Barang]
                                    </Text>
                                  }

                                  {data.data[key].barang_nama ?
                                    <Text lineClamp={1}>
                                      {safeValue(data.data[key].barang_nama, '[Nama Barang]')}
                                    </Text>
                                    :
                                    <Text lineClamp={1} color='dimmed'>
                                      [Nama Barang]
                                    </Text>
                                  }

                                  {data.data[key].barang_keluhan ?
                                    <Text lineClamp={1}>
                                      {safeValue(data.data[key].barang_keluhan, '[Keluhan]')}
                                    </Text>
                                    :
                                    <Text lineClamp={1} color='dimmed'>
                                      [Keluhan]
                                    </Text>
                                  }
                                </Box>
                              }
                              stateDivider={true}
                            />

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='Tanggal Masuk'
                              stateContent={sqlDateToHumanDate({
                                stateDate: data.data[key].tanggal_nota,
                                stateWithTime: false,
                                stateLang: 'id',
                                stateIsShort: false,
                                stateDay: false,
                                stateDefaultValue: ' - ',
                                stateDateType: 'day'
                              })}
                              stateDivider={true}
                            />

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='Deadline Pengecekan'
                              stateContent={
                                <Box>
                                  <Text>
                                    {sqlDateToHumanDate({
                                      stateDate: data.data[key].date_line_pengecekan,
                                      stateWithTime: false,
                                      stateLang: 'id',
                                      stateIsShort: false,
                                      stateDay: false,
                                      stateDefaultValue: ' - ',
                                      stateDateType: 'day'
                                    })}
                                  </Text>

                                  <DeadlinePengecekan
                                    stateToday={data.data[key].today}
                                    stateDeadlinePengecekan={data.data[key].date_line_pengecekan}
                                    stateHasPengecekan={data.data[key].has_pengecekan}
                                  />
                                </Box>
                              }
                              stateDivider={true}
                            />

                            <LabelContentInline
                              stateColLabel={4}
                              stateLabel='Deadline Selesai'
                              stateContent={
                                <Box>
                                  <Text>
                                    {sqlDateToHumanDate({
                                      stateDate: data.data[key].date_line_selesai,
                                      stateWithTime: false,
                                      stateLang: 'id',
                                      stateIsShort: false,
                                      stateDay: false,
                                      stateDefaultValue: ' - ',
                                      stateDateType: 'day'
                                    })}
                                  </Text>

                                  <DeadlineSelesai
                                    stateToday={data.data[key].today}
                                    stateDeadlineSelesai={data.data[key].date_line_selesai}
                                    stateTanggalSelesai={data.data[key].tanggal_selesai}
                                  />
                                </Box>
                              }
                              stateDivider={true}
                            />

                            <LabelContentInline
                              stateColLabel={0}
                              stateLabel=''
                              stateContent={
                                <Group position='center'>
                                  <Button
                                    fullWidth
                                    size='sm'
                                    disabled={data.data[key].project_process === utils.projectProcess.nota.value}
                                    onClick={data.data[key].project_process === utils.projectProcess.nota.value ? () => { } : () => fnGoToStep(data.data[key])}
                                  >
                                    {getObjectParam2(utils.projectProcess, data.data[key].project_process, 'caption', 'Proses')}
                                  </Button>
                                </Group>
                              }
                              stateDivider={false}
                            />
                          </Text>
                        </Card.Section>
                      </Card>
                    )
                  })}
                </SimpleGrid>
              </Grid.Col>
            </Grid>
          </Container>
        }
      </Modal>
    </React.Fragment>
  )
}

export default PopUpTeknisiTasks;